import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroller til toppen av vinduet (0, 0) hver gang 'pathname' (URL-en) endrer seg
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Denne komponenten rendrer ingenting, den utfører kun en handling
}

export default ScrollToTop;